import React from 'react';

// Stub component - NewContract module deleted
const MetaMaskForm = ({ from, accessType, productList, ...props }) => {
  return (
    <div>
      <p>MetaMask functionality removed - NewContract module deleted</p>
    </div>
  );
};

export default MetaMaskForm;

